import React, { Component } from 'react';
import { MutationLoading } from 'components/LoadingPage';
import Alert from '@creditcards/ui-kit-react/lib/components/Alert';
import PropTypes from 'prop-types';
import SlackAlertForm from 'components/SlackAlertForm';
import { CREATE_SLACK_ALERT, GET_ENV } from 'containers/Environments/queries';
import { getStatusEnumsFromForm } from 'utils/enums';

import style from './style.module.css';

class SlackAlertInlineAdd extends Component {
  static propTypes = {
    environmentId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired
  };

  render() {
    const { onClose, environmentId } = this.props;

    return (
      <div className={style.container} data-cy="slack-notification-form">
        <MutationLoading
          mutation={CREATE_SLACK_ALERT}
          onCompleted={onClose}
          refetchQueries={[
            { query: GET_ENV, variables: { id: environmentId } }
          ]}
        >
          {(createSlackAlert, { error, loading }) => (
            <React.Fragment>
              {error ? <Alert type="danger" message={error.message} /> : null}
              <div className={style.heading}>New Alert</div>
              <SlackAlertForm
                gqlError={error}
                loading={loading}
                onCancel={onClose}
                onSubmit={form =>
                  createSlackAlert({
                    variables: {
                      slackAlert: {
                        channel: form.channel,
                        on: getStatusEnumsFromForm(form.on),
                        environmentId
                      }
                    }
                  })
                }
              />
            </React.Fragment>
          )}
        </MutationLoading>
      </div>
    );
  }
}

export default SlackAlertInlineAdd;
